/**
 * AFP: tasas y opciones del selector — fuente única del frontend.
 *
 * La tasa del trabajador es 10% obligatorio + la comisión de la administradora.
 * Debe coincidir con `AFP_RATES` en `backend/apps/payroll/models.py`, que es la
 * que el motor aplica al calcular (el backend autocompleta `afp_rate` al guardar
 * la configuración previsional).
 *
 * El porcentaje del rótulo se DERIVA de la tasa, nunca se escribe a mano: el
 * selector llegó a mostrar "AFP Uno (10,69%)" mientras se descontaba 10,46%
 * porque el rótulo quedó congelado cuando la comisión bajó (reportado por
 * Jacqueline, 2026-07-27). Al actualizar una tasa, cambiar solo este objeto.
 *
 * Comisiones vigentes según la Superintendencia de Pensiones (Uno bajó a 0,46%
 * el 01-10-2025): https://www.spensiones.cl/portal/institucional/594/w3-propertyvalue-9897.html
 */
export const AFP_RATES: Record<string, string> = {
  capital: '11.44',
  cuprum: '11.44',
  habitat: '11.27',
  modelo: '10.58',
  planvital: '11.16',
  provida: '11.45',
  uno: '10.46',
}

export const AFP_NAMES: Record<string, string> = {
  capital: 'Capital',
  cuprum: 'Cuprum',
  habitat: 'Habitat',
  modelo: 'Modelo',
  planvital: 'PlanVital',
  provida: 'ProVida',
  uno: 'Uno',
}

/** Opciones del selector. `prefix` antepone "AFP " al nombre. */
export function afpOptions(prefix = true): { value: string; label: string }[] {
  return Object.entries(AFP_NAMES).map(([value, name]) => ({
    value,
    label: `${prefix ? 'AFP ' : ''}${name} (${AFP_RATES[value]}%)`,
  }))
}
